<div class="content">
    <div>
        <ng-content></ng-content>
    </div>

</div>
